import { useLanguageContext } from "../../context/LanguageContext";

function PortalInvalidPageView() {
  const { translate } = useLanguageContext();

  return (
    <h2
      style={{
        marginInline: "auto",
        textAlign: "center",
        marginTop: "2rem",
        paddingInline: "2rem",
      }}
    >
      {translate("eva.main.messages.portal.invalid")}
    </h2>
  );
}

export default PortalInvalidPageView;
